import { render, staticRenderFns } from "./passwordreset.vue?vue&type=template&id=157945da&scoped=true&"
import script from "./passwordreset.vue?vue&type=script&lang=js&"
export * from "./passwordreset.vue?vue&type=script&lang=js&"
import style0 from "./passwordreset.vue?vue&type=style&index=0&id=157945da&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "157945da",
  null
  
)

export default component.exports